import { useState, useEffect } from 'react';
import './index.scss'
import Loader from 'react-loaders';
import AnimatedLetters from '../AnimatedLetters';
import projectData from '../../data/project.json';
import ProjectCard from '../ProjectCard';

const Projects = () => {
  const [letterClass, setLetterClass] = useState('text-animate')

  const renderProjects = (projects) => {

    return (
      <div className='images-container'>
        {
          projects.map((port, key) => {
            return (
              <ProjectCard 
                key={key}
                title={port.title}
                description={port.description}
                stack={port.stack}
                cover={port.cover}
                url={port.url}
              />
            )
          })
        } 
      </div>
    )
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setLetterClass('text-animate-hover');
    }, 3000);

    return () => {
      clearTimeout(timer);
    }  
  });
  

  return (
    <>
      <div className='container project-page'>
        <h1 className='page-title'>
          <AnimatedLetters 
            letterClass={letterClass}
            strArray={'Projects'.split('')}
            idx={15}
          />
        </h1>
        <div>{renderProjects(projectData.projects)}</div>
      </div>
      <Loader type="pacman" /> 
    </>
  )
}

export default Projects;
